export const SLICE_TYPES = {
    TOPIC: 'TOPIC',
};
